export default __webpack_public_path__ + "static/media/thumbs-down.562299ee.svg";